// Querys and Mutations
import {
    ALL,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE
} from '@/graphql/config/UsersGraphql'

// models
import { UsersWithPagination, UserInput, UserModel, Paginator } from '@/models'

// apollo
import { apolloClient } from '@/apollo'

class UsersService {
    /**
     * Queries
     */
    async getAll (email = '', status: boolean|null = null): Promise<UserModel[]> {
        const result = await apolloClient.query({
            query: ALL,
            variables: {
              email,
              status
            }
        })
        return result.data.users
    }

    async getWithPagination (perPage = 10, page = 1, search = ''): Promise<UsersWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage,
                search
            }
        })
        const pagination: Paginator = result.data.usersWithPagination.paginatorInfo
        const data: UserModel[] = result.data.usersWithPagination.data
        const response: UsersWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
    async create (form: UserInput): Promise<UserModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
              input: form
            }
        })
        return result.data.createUser
    }

    async update (id: number, form: UserInput): Promise<UserModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
              id: id,
              input: form
            }
        })
        return result.data.updateUser
    }

    async delete (id: number): Promise<boolean> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
              id: id
            }
        })
        return true
    }
}

export default new UsersService()
